<template>
  <div>
    <div v-show="isReady">
      <client-only>
        <div
          class="nav__meta--mobile"
          v-if="
            loggedIn &&
              availableCompanies !== 0 &&
              currentCustomer.customerUuid !== 'default'
          "
        >
          <div class="nav__meta__container">
            <div
              v-if="availableCompanies === 1"
              class="customerLabel"
            >
              <span v-tv="currentCustomer.customerLabel" />
            </div>
            <DropDown
              v-else
              :data-items="customers"
              :text-field="'customerLabel'"
              :data-item-key="'customerUuid'"
              :value="currentCustomer"
              :filterable="true"
              @filterchange="onCustomerFilterChange"
              @change="changeCompany"
              :loading="customerLoading"
              :skip-client-filter="true"
              :filter="customerFilter"
              :key="rerender"
            />
          </div>
        </div>
      </client-only>
      <div class="pure-u-1 nav__meta">
        <div class="nav__meta__container nav__meta__container__language">
          <client-only>
            <DropDown
              class="dropdown--with-icon"
              :data-items="langSwitch"
              :value-render="iconDropdownValueRenderer"
              :text-field="'label'"
              :data-item-key="'value'"
              :value="langSwitch.find(p => p.value === $i18n.locale)"
              @change="changeLocale"
              id="languageswitch"
            >
              <template #iconDropdownTemplate="{ props }">
                <iconDropdownValueRenderer
                  :value="props.value ? props.value.label : ''"
                >
                  <Translate />
                </iconDropdownValueRenderer>
              </template>
            </DropDown>
          </client-only>
        </div>
        <div
          class="nav__meta__container nav__meta__container__region"
          v-show="!loggedIn"
        >
          <client-only>
            <DropDown
              class="dropdown--with-icon"
              :data-items="regionSwitch"
              :value-render="iconDropdownValueRenderer"
              :value="regionValue"
              :text-field="'label'"
              :data-item-key="'value'"
              @change="changeRegion"
            >
              <template #iconDropdownTemplate="{ props }">
                <iconDropdownValueRenderer
                  :value="props.value ? props.value.label : ''"
                >
                  <MapsLocationPin />
                </iconDropdownValueRenderer>
              </template>
            </DropDown>
          </client-only>
        </div>
        <div
          class="nav__meta__container nav__meta__container__company"
          v-if="
            loggedIn &&
              availableCompanies !== 0 &&
              currentCustomer.customerUuid !== 'default'
          "
        >
          <client-only>
            <div
              v-if="availableCompanies === 1"
              class="customerLabel"
            >
              <iconDropdownValueRenderer
                :value="currentCustomer.customerLabel"
                class="dropdown--with-icon"
              >
                <SocialPerson class="svg-social-person" />
              </iconDropdownValueRenderer>
            </div>
            <DropDown
              v-else
              class="dropdown--with-icon"
              :data-items="customers"
              :text-field="'customerLabel'"
              :data-item-key="'customerUuid'"
              :value="currentCustomer"
              :filterable="true"
              :value-render="iconDropdownValueRenderer"
              @filterchange="onCustomerFilterChange"
              @change="handleCompanyChange"
              @close="handleCompanyChange"
              :filter="customerFilter"
            >
              <template #iconDropdownTemplate="{ props }">
                <iconDropdownValueRenderer :value="props.value.customerLabel">
                  <CustomerIcon class="svg-social-person" />
                </iconDropdownValueRenderer>
              </template>
            </DropDown>
          </client-only>
        </div>
        <div class="nav__meta__container nav__meta__container--icon-only">
          <nuxt-link
            class="link--icon-only"
            :to="localePath('/guides')"
          >
            <ActionHelpFilled
              class="svg-icon-help"
              :title="$tv('services.questionIconTooltip', 'header')"
            />
            <span>{{ $tv('services.questionLabel', 'header') }}</span>
          </nuxt-link>
        </div>
        <!--TODO: Implement Wishlist -->
        <!-- <div class="nav__meta__container nav__meta__container--icon-only">
          <nuxt-link
            class="link--icon-only"
            to="#"
          >
            <span
              :title="$tv('services.starIconTooltip', 'header')"
            >
              <ToggleStarOutline />
            </span>
          </nuxt-link>
        </div> -->
        <div
          class="nav__meta__container nav__meta__container--icon-only"
          v-show="loggedIn && runAtleastOnce"
        >
          <div
            class="nav__meta__container__notifications"
            :class="{'has-notification-label': getNotificationsLabelText != null}"
          >
            <NotificationBell
              @bell-clicked="tooltip = !tooltip"
              :unread-notifications-length="unreadNotifications.length"
            />
            <span
              v-show="getNotificationsLabelText"
              class="display-lg clickable"
              @click="tooltip = !tooltip"
              v-text="getNotificationsLabelText"
            />
            <div
              class="nav__meta__container--tooltip"
              v-show="unreadNotifications.length > 0"
            >
              <NotificationTT
                class="tooltip"
                :show-tool-tip="tooltip"
                :has-padding="false"
                tool-tip-position="bottom"
                arrow-position-vertically="top"
                arrow-position-horizontally="right"
              >
                <div class="nav__meta__container--tooltip__header">
                  <span>
                    {{ $tv('notifications', 'notifications') }}
                  </span>
                  <a
                    href="javascript:void(0)"
                    @click="tooltip = false"
                  >
                    <NavigationClose />
                  </a>
                </div>
                <NotificationList
                  :notifications="unreadNotifications"
                  :notifications-hidden="notificationsHidden"
                />
              </NotificationTT>
            </div>
          </div>
        </div>
        <div
          class="nav__meta__container nav__meta__container--icon-only"
          v-show="loggedIn && !runAtleastOnce && availableCompanies !== 0"
        >
          <div>
            <!-- <waiting-indicator /> -->
          </div>
        </div>
        <div
          class="nav__meta__container nav__meta__container__contact"
        >
          <client-only>
            <DropDown
              class="dropdown--with-icon"
              :data-items="getContactMenu"
              :value-render="iconDropdownValueRenderer"
              :value="''"
              :text-field="'label'"
              @select="contactMenu"
              :popup-settings="{ popupClass: salesContactPhone ? 'contact-dropdown-popup contact-dropdown-with-phone' : 'contact-dropdown-popup' }"
            >
              <template #iconDropdownTemplate>
                <iconDropdownValueRenderer>
                  <CommunicationEmail />
                </iconDropdownValueRenderer>
              </template>
            </DropDown>
          </client-only>
        </div>
        <div
          class="nav__meta__container nav__meta__container__login"
          v-show="!loggedIn"
        >
          <a
            class="link--with-icon"
            href="#"
            @click.prevent="login"
            rel="nofollow"
          >
            <SocialPerson class="svg-social-person link__icon" />
            <span>{{ $tv('Login') }}</span>
          </a>
        </div>
        <div
          class="nav__meta__container nav__meta__container__login"
          v-if="loggedIn"
        >
          <DropDown
            class="dropdown--with-icon"
            :data-items="getProfileMenu"
            :value-render="iconDropdownValueRenderer"
            :item-render="'iconDropdownItemTemplate'"
            :value="''"
            :text-field="'label'"
            @change="serviceMenu"
          >
            <template #iconDropdownTemplate>
              <iconDropdownValueRenderer :value="getUserName">
                <SocialPerson class="svg-social-person" />
              </iconDropdownValueRenderer>
            </template>
            <template #iconDropdownItemTemplate="{ props }">
              <li
                class="k-list-item profile-menu-item"
                :class="{ 'k-focus': props.focused, 'k-selected': props.selected, 'profile-menu-item__external-link': props.dataItem?.showExternalUrl }"
                @click="props.onClick"
              >
                <span class="k-list-item-text">{{ props.dataItem?.label }}</span>
                <OpenInNewTabIcon
                  v-if="props.dataItem?.showExternalUrl"
                  class="profile-menu-item__external-icon"
                />
              </li>
            </template>
          </DropDown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OpenInNewTabIcon from '~/assets/icons/open_in_new.svg?component'
import DropDown from '~/components/input-components/DropDown'
import IconDropdownValueRender from './IconDropdownValueRender.vue'
import {useImportantMessagesService} from '@/composables/important_messages_service'
import NotificationBell from '../notifications/NotificationBell'
import ToolTip from '@/components/ToolTip.vue'
import {mapActions} from 'pinia'
import NotificationList from '~/components/notifications/NotificationList.vue'
import {useCustomerService} from '@/composables/customer_service'
import {filterBy} from '@progress/kendo-data-query'
import {MAX_CUSTOMERS, USER_RIGHTS_MAPPING, ADDRESS_TYPE, CUSTOMER_SETTING_KEYS} from '~/assets/js/constants'
import Translate from '~/assets/icons/action_translate.svg?component'
import MapsLocationPin from '~/assets/icons/maps_location_pin.svg?component'
import SocialPerson from '~/assets/icons/social_person.svg?component'
import CommunicationEmail from '~/assets/icons/communication_email.svg?component'
import CustomerIcon from '~/assets/icons/action_customer_icon.svg?component'
import ActionHelpFilled from '~/assets/icons/action_help_filled.svg?component'
import NavigationClose from '~/assets/icons/navigation_close.svg?component'
import {isArrowKey, isESCKey} from '~/assets/js/check_for_key_helper.js'
import {useNotificationStore} from '@/store/notification'
import {useUserStore} from '@/store/user'
import {useCartStore} from '@/store/cart'
import {usePlantStore} from '@/store/plants'
import {useCustomerSettingsStore} from '@/store/customer-settings'
import {useImportantMessagesStore} from '@/store/important-messages'
import {storeToRefs} from 'pinia'
import {fetchUser} from '~/assets/js/authentication/azureb2cNew'
import {useKeycloakUser} from '~/composables/keycloak'
import {isKeycloakAuth} from '~/composables/useAuthProvider'
import {getRegionForSalesArea} from '~/assets/js/utils/region_service'
import {useGtm} from '@gtm-support/vue-gtm'
import {useEventItemConverter} from '@/composables/useEventItemConverter'

export default {
  components: {
    iconDropdownValueRenderer: IconDropdownValueRender,
    NotificationBell,
    'NotificationTT': ToolTip,
    NotificationList,
    DropDown,
    Translate,
    MapsLocationPin,
    SocialPerson,
    ActionHelpFilled,
    NavigationClose,
    CustomerIcon,
    CommunicationEmail,
    OpenInNewTabIcon
  },
  props: {
    isReady: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  setup() {
    const {getImportantMessages} = useImportantMessagesService()
    const {getFilteredCustomerListV2} = useCustomerService()

    const {unreadNotifications, runAtleastOnce} = storeToRefs(useNotificationStore())
    const {selectedCustomer, companies, availableCompanies, accessToken, name} = storeToRefs(useUserStore())
    const {currentCustomerSettings, currentDamIntegrationSettings} = storeToRefs(useCustomerSettingsStore())

    return {
      getFilteredCustomerListV2,
      getImportantMessages,
      unreadNotifications,
      runAtleastOnce,
      selectedCustomer,
      companies,
      availableCompanies,
      accessToken,
      name,
      currentCustomerSettings,
      currentDamIntegrationSettings
    }
  },
  fetchOnServer: false,
  async mounted() {
    if (this.loggedIn) {
      if (
        this.selectedCustomer &&
        (this.selectedCustomer.customerUuid !== this.currentCustomer.customerUuid ||
          this.selectedCustomer.customerLabel !== this.currentCustomer.customerLabel)
      ) {
        this.currentCustomer = {
          ...this.currentCustomer,
          customerUuid: this.selectedCustomer.customerUuid,
          customerLabel: this.selectedCustomer.customerLabel
        }
      }
    }
    await this.fetchImportantMessages()
    this.init_store_client()
  },
  data: function() {
    return {
      iconDropdownValueRenderer: 'iconDropdownTemplate',
      currentCustomer: {
        customerUuid: 'default',
        customerLabel: this.$tv('loading...')
      },
      languagesData: [],
      tooltip: false,
      notificationsHidden: {},
      customerLoading: false,
      customers: [],
      requestTimeout: null,
      filter: null,
      isCustomerSet: true,
      customerFilter: null,
      eventTimeout: null,
      rerender: 0
    }
  },
  watch: {
    selectedCustomer(val) {
      if (val && (val.customerUuid !== this.currentCustomer.customerUuid ||
        val.customerLabel !== this.currentCustomer.customerLabel)) {
        this.currentCustomer.customerUuid = val.customerUuid
        this.currentCustomer.customerLabel = val.customerLabel
      }
    },
    '$i18n.locale': {
      immediate: true,
      async handler() {
        this.languagesData = this.$i18n?.locales
      }
    },
    'companies': {
      immediate: true,
      handler(val) {
        this.customers = val ? val.slice(0) : []
        this.rerender++
      }
    }
  },
  computed: {
    salesContactPhone() {
      const setting = this.currentCustomerSettings?.find(s => s.translationKey === CUSTOMER_SETTING_KEYS.SalesContactPhone)
      return setting?.customerSettingValue || ''
    },
    getContactMenu() {
      let contactMenuArray = [
        {
          label: this.$tv('contact', 'navigation'),
          onClick: () => this.$eventbus.emit('showContactPopup')
        }
      ]

      if (this.salesContactPhone) {
        contactMenuArray.push({
          label: this.salesContactPhone,
          onClick: () => this.copyPhoneToClipboard()
        })
      }

      return contactMenuArray
    },
    getNotificationsLabelText() {
      if (this.unreadNotifications.length === 1) {
        return this.$tv('notification', 'notifications')
      } else if (this.unreadNotifications.length > 1) {
        return this.$tv('notifications', 'notifications')
      }
      return null
    },
    getProfileMenu() {
      let profileMenuArray = [
        {
          label: this.$tv('profile.profile', 'header'),
          localRoute: '/profile'
        }
      ]

      if (this.selectedCustomer?.customerUuid !== 'default') {
        profileMenuArray.push({
          label: this.$tv('headerManagement.companyInformation', 'management'),
          localRoute:
            '/management/' +
            this.$tv(
              'management-companyinformation',
              'pages',
              'companyinformation'
            )
        })

        profileMenuArray.push({
          label: this.$tv('headerManagement.addresses', 'management'),
          localRoute: '/management/' + this.$tv('management-addresses', 'pages', null)
        })

        if (this.hasRight(USER_RIGHTS_MAPPING.USER_VIEW)) {
          profileMenuArray.push({
            label: this.$tv('headerManagement.users', 'management'),
            localRoute:
                '/management/' + this.$tv('management-users', 'pages', 'users')
          })
        }

        if (this.hasRight(USER_RIGHTS_MAPPING.CUSTOMER_BUSINESSCONNECTOR_VIEW)) {
          profileMenuArray.push({
            label: this.$tv('headerManagement.ebcSettings', 'management'),
            localRoute: '/management/' + this.$tv('management-ebcsettings', 'pages', null)
          })
        }

        if (this.currentCustomerSettings?.find(s => s.translationKey === CUSTOMER_SETTING_KEYS.DAMAccessAvailable)?.customerSettingValue === '1') {
          profileMenuArray.push({
            label: this.$tv('headerManagement.mediaAssets', 'management'),
            externalUrl: '',
            showExternalUrl: true
          })
        }

        profileMenuArray.push({
          label: this.$tv('headerManagement.csvCatalog', 'management'),
          localRoute: '/management/' + this.$tv('management-csvcatalog', 'pages', null)
        })
      }

      profileMenuArray.push({
        label: this.$tv('profile.logout', 'header'),
        logoutButton: true
      })

      return profileMenuArray
    },
    regionSwitch() {
      return (
        (this.$i18n.locale &&
          this.$config.public.regions?.map(l => ({
            label: this.$tv(l.RegionName, 'regions'),
            value: l.RegionShortName
          }))) ||
        []
      )
    },
    regionValue() {
      return this.regionSwitch.find(
        p => p.value === this.$globalization.__currentRegion
      )
    },
    getUserName() {
      return this.name
    },
    langSwitch() {
      let languages = this.$i18n?.locales.map(l => ({
        label: this.$tv(l.code, 'locales'),
        value: l.code
      }))

      return languages
    },
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  methods: {
    ...mapActions(useNotificationStore, ['resetRunAtleastOnce', 'resetPollingTimer', 'startPolling', 'init_store_client']),
    ...mapActions(useCartStore, ['setSelectedAddress']),
    ...mapActions(usePlantStore, ['fetchAllPlants']),
    ...mapActions(useCustomerSettingsStore, ['fetchCustomerSettings', 'fetchDAMIntegrationSettings']),
    ...mapActions(useUserStore, ['setSelectedCustomer']),
    ...mapActions(useImportantMessagesStore, ['fetchMessages']),
    async copyPhoneToClipboard() {
      if (this.salesContactPhone) {
        await navigator.clipboard.writeText(this.salesContactPhone)
        useGtm()?.trackEvent(useEventItemConverter().convert({
          event: 'show_phone_number_click',
          add_personalization: true,
          props: {page: this.$route?.path || ''}
        }))
      }
    },
    async changeLocale(e) {
      this.$eventbus.emit('loading', true)
      await this.$i18n.setLocale(e.value.value)
      await this.$nextTick()
      this.$emit('reload-translations')
      this.fetchImportantMessages()
    },
    async changeRegion(e) {
      this.$globalization.switchRegion(e.value.value)
    },
    contactMenu(e) {
      if (e.dataItem?.onClick && typeof e.dataItem.onClick === 'function') {
        e.dataItem.onClick()
      }
    },
    serviceMenu(e) {
      if (e.value?.logoutButton) {
        navigateTo({path: '/auth/logout'})
        return
      }

      if (e.value.localRoute) {
        this.$router.push(this.localePath(e.value.localRoute))
      }
      else if (!e.value.externalUrl && e.value.showExternalUrl) {
        this.fetchDAMIntegrationSettings().then(() => {
          const damUrl = this.currentDamIntegrationSettings?.loginUrl
          if (damUrl) {
            window.open(damUrl, '_blank', 'noopener,noreferrer')
          } else {
            // eslint-disable-next-line no-console
            console.warn('DAM URL setting is not configured.')
          }
        }).catch(error => {
          // eslint-disable-next-line no-console
          console.error('Error fetching DAM integration settings:', error)
        })
      }
      else if (e.value.externalUrl) {
        window.open(e.value.externalUrl, '_blank')
      }
    },
    login() {
      this.$emit('login')
    },
    handleCompanyChange(e) {
      clearTimeout(this.eventTimeout)
      this.eventTimeout = setTimeout(() => this.changeCompany(e), 50)
    },
    async changeCompany(e) {
      this.currentCustomer = {
        ...this.currentCustomer,
        customerUuid: e.value.customerUuid,
        customerLabel: e.value.customerLabel
      }
      if (
        !isArrowKey(e) &&
        !isESCKey(e) &&
        this.selectedCustomer?.customerUuid !==
          this.currentCustomer.customerUuid
      ) {
        const newCustomerLocal = this.customers.find(c => c.customerUuid === this.currentCustomer.customerUuid)
        this.resetRunAtleastOnce()
        this.resetPollingTimer()
        this.$emit('change-customer')
        await this.$nextTick()
        this.setSelectedAddress({address: null, type: ADDRESS_TYPE.Delivery})
        this.setSelectedAddress({address: null, type: ADDRESS_TYPE.Invoice})
        const {newCustomer} = storeToRefs(useUserStore())
        newCustomer.value = newCustomerLocal.customerUuid
        const newRegion = getRegionForSalesArea(`${newCustomerLocal?.salesOrg}-${newCustomerLocal?.salesChannel}-${newCustomerLocal?.distribution}`)
        if (this.$globalization.__currentRegion !== newRegion) {
          this.$globalization.switchRegion(newRegion, true)
        }
        const app = useNuxtApp()

        // Parallelize independent async operations for better performance
        try {
          // Check if Keycloak is enabled and use appropriate customer switch function
          const isKeycloakEnabled = isKeycloakAuth()

          if (isKeycloakEnabled) {
            const {switchKeycloakCustomer} = useKeycloakUser()
            await Promise.all([
              switchKeycloakCustomer(newCustomerLocal.customerUuid, 'change_company'),
              this.fetchAllPlants(true),
              this.fetchCustomerSettings()
            ])
          } else {
            await Promise.all([
              fetchUser(app.$userManager, 'change_company'),
              this.fetchAllPlants(true),
              this.fetchCustomerSettings()
            ])
          }
        } catch (error) {
          if (app.$sentry) {
            app.$sentry.captureException(error)
          }
        }

        await this.fetchImportantMessages()

        // Start polling after data is loaded
        this.startPolling()
        this.onCustomerFilterChange({filter: null})
        this.$emit('change-customer')
      } else if (isESCKey(e)) {
        this.currentCustomer = {
          ...this.currentCustomer,
          customerUuid: this.selectedCustomer?.customerUuid,
          customerLabel: this.selectedCustomer?.customerLabel
        }
      }
    },
    async fetchImportantMessages() {
      this.fetchMessages(
        await this.getImportantMessages(
          this.$i18n.locale,
          this.$globalization.getRegion()
        )
      )
    },
    async onCustomerFilterChange(event) {
      const filter = event.filter
      this.customerFilter = filter?.value ?? null

      // Store previous customers for rollback on error
      const previousCustomers = this.customers.slice(0)

      if (this.availableCompanies > MAX_CUSTOMERS) {
        // Show loading indicator without replacing data
        this.customerLoading = true

        if (this.requestTimeout) {
          clearTimeout(this.requestTimeout)
        }

        // Reduced debounce from 200ms to 100ms for better responsiveness
        this.requestTimeout = setTimeout(async () => {
          this.filter = filter

          try {
            const newCustomerData = await this.getFilteredCustomerListV2(
              filter,
              MAX_CUSTOMERS
            )

            if (
              newCustomerData &&
              Array.isArray(newCustomerData) &&
              filter?.value === this.filter?.value
            ) {
              this.customers = newCustomerData.slice(0)
            } else if (!newCustomerData || newCustomerData.length === 0) {
              // Restore previous data if no results
              this.customers = previousCustomers
            }
          } catch {
            this.customers = previousCustomers
          } finally {
            this.customerLoading = false
          }
        }, 100)
      } else {
        this.customers = filterBy(this.companies.slice(0), filter)
        this.customerLoading = false
      }
    }
  }
}
</script>
<style lang="scss">
.nav__meta__container__company {
  .customerLabel {
    align-items: center;
    margin: auto;
    padding-left: .5rem;
    padding-right: .5rem;
    padding-top: .25rem;
    overflow: hidden;

    .dropdown--with-icon {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: $base-text-font-weight-semi-bold;
    }
  }
}

.nav__meta__container__contact {
  max-width: 6rem;
}

.contact-dropdown-popup.contact-dropdown-with-phone .k-list-item:last-child .k-list-item-text::after {
  content: '';
  display: inline-block;
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
  vertical-align: middle;
  background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.077 23.3333C11.4034 23.3333 10.8333 23.1 10.3667 22.6333C9.9 22.1667 9.66667 21.5966 9.66667 20.923V5.74366C9.66667 5.07011 9.9 4.49999 10.3667 4.03333C10.8333 3.56666 11.4034 3.33333 12.077 3.33333H23.2563C23.9299 3.33333 24.5 3.56666 24.9667 4.03333C25.4333 4.49999 25.6667 5.07011 25.6667 5.74366V20.923C25.6667 21.5966 25.4333 22.1667 24.9667 22.6333C24.5 23.1 23.9299 23.3333 23.2563 23.3333H12.077ZM7.41033 28C6.73678 28 6.16667 27.7667 5.7 27.3C5.23333 26.8333 5 26.2632 5 25.5897V8.41033H7V25.5897C7 25.6923 7.04278 25.7863 7.12833 25.8717C7.21367 25.9572 7.30767 26 7.41033 26H20.5897V28H7.41033Z' fill='currentColor'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.7;
}

.contact-dropdown-popup .k-list-item:last-child:hover .k-list-item-text::after {
  opacity: 1;
}

.nav__meta__container__notifications {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .count {
    font-size: $base-text-font-size;
  }

  &.has-notification-label {
    padding-left: .925rem;
  }

  span.display-lg {
    margin-left: .2rem;
    font-size: $base-text-font-size;
  }
}

.nav .nav__meta .nav__meta__container__notifications .nav__meta__container--tooltip {
  top: .8125rem;
}

.nav .nav__meta .nav__meta__container__notifications.has-notification-label .nav__meta__container--tooltip .tool-tip__wrapper.arrow.arrow-right::after {
  @include breakpoint-up($lg) {
    right: 7.4rem;
  }
}

.display-lg {
  @include breakpoint-up($lg) {
    display: inline-block;
  }

  @include breakpoint-down($lg) {
    display: none;
  }
}

.k-animation-container:has(.contact-dropdown-popup) {
  width: auto !important;
  min-width: 6.063rem !important;
}

.profile-menu-item {
  display: flex !important;

  &__external-link {
    justify-content: space-between;
  }

  &__external-icon {
    width: 1.125rem!important;
    height: 1.125rem!important;
    color: $color__primary!important;
  }
}
</style>
